<script setup lang="ts">
import type { SelectProps } from "./select.types";
import { useSelectSetup } from "./useSelect";
import { VisuallyHiddenInput } from "components/VisuallyHidden";

defineOptions({ name: "ESelect" });

const props = withDefaults(defineProps<SelectProps>(), {
  color: "neutral",
  variant: "subtle",
  size: "md",
  block: false,
  multiple: false,
  disabled: false,
  required: false,
  open: false,
});

const { state, classes } = useSelectSetup({ props });
</script>

<template>
  <div
    part="base"
    :class="classes"
    class="e-select"
    :data-disabled="state.disabled?.value || undefined"
    :data-open="state.open?.value || undefined"
  >
    <slot />

    <visually-hidden-input
      :name="state.name?.value"
      :value="state.modelValue?.value"
      :required="state.required?.value"
      :disabled="state.disabled?.value"
    />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
